module.exports = __webpack_public_path__ + "img/media_20240408_224931_2677889545233991578.13a102be.jpg";